import { jsx } from "react/jsx-runtime";
import { useMemo, useState, useCallback, createElement } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { Autocomplete, Button } from "@mui/material";
import "lottie-react";
import "../../../../../themes/shadows/shadows.js";
import "../../../../../themes/typography/typography.js";
import "../../../../../components/avatar-group/avatar-group.styles.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.js";
import "../../../../../components/date-pickers/date-picker/theme/index.js";
import "../../../../../components/dialog/dialog.js";
import "../../../../../components/icons/all/all.js";
import "../../../../../components/label/label.styles.js";
import { MenuItem } from "../../../../../components/menu-item/menu-item.js";
import "../../../../../components/slider/slider.styles.js";
import "@mui/material/styles";
import "../../../../../components/snackbar/snackbar.styles.js";
import { StyledTextField } from "../../../../../components/styled-text-field/styled-text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.js";
import "../../../../../components/translations/utils.js";
import "../../../../../components/time-select/time-select.styles.js";
import "../../../../../components/time-interval-select/time-interval-select.styles.js";
import { format, parse } from "date-fns";
import debounce from "lodash/debounce.js";
import { PatientIcon } from "../../assets/icons/Patient.js";
import { usePrevious } from "../../helpers/common.js";
import { usePatientSearch } from "../../hooks/usePatientSearch.js";
import { LABEL_OFFSET } from "../appointment-form/appointment-form.constants.js";
import { PatientAutocompleteSkeleton } from "./patient-autocomplete.skeleton.js";
import { StyledListbox, AddNewPatientWrapper, StyledMenuItem, StyledLabelBirthDay } from "./patient-autocomplete.styles.js";
import "../../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "@mui/system";
import "@mui/material/Button/index.js";
import "@mui/x-date-pickers/internals/index.js";
import "../../../../../constants/create-theme/create-theme.js";
import "../../../../../constants/colors/palette.js";
import "../../../../../themes/button/button.js";
import "../../../../../themes/button/styles/external/bordered.styles.js";
import "color-alpha";
import "../../../../../themes/button/styles/external/filled.styles.js";
import "../../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.styles.js";
import "../../../../../themes/date-calendar/date-calendar.js";
import "../../../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../../../../themes/day-calendar/day-calendar.js";
import "../../../../../themes/filled-input/filled-input.js";
import "../../../../../themes/form-helper-text/form-helper-text.js";
import "../../../../../themes/form-label/form-label.js";
import "../../../../../themes/month-calendar/month-calendar.js";
import "../../../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../../../../themes/pickers-day/pickers-day.js";
import "@mui/x-date-pickers";
import "../../../../../themes/pickers-month/pickers-month.js";
import "../../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../../../../themes/pickers-year/pickers-year.js";
import "../../../../../themes/year-calendar/year-calendar.js";
import "@mui/icons-material/Close.js";
import "../../../../../themes/alert/alert.js";
import "../../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../../themes/dialog/dialog.js";
import "../../../../../themes/external-theme/external-theme.js";
import "../../../../../constants/breakpoints/breakpoints.js";
import "../../../../../themes/checkbox/checkbox.js";
import "../../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../../themes/form-control-label/form-control-label.js";
import "../../../../../themes/radio/radio.js";
import "../../../../../themes/switch/switch.js";
import "../../../../../themes/popover/popover.js";
import "../../../../../themes/tooltip/tooltip.js";
import "../../../../../components/dialog/dialog.constants.js";
import "../../../../../components/dialog/dialog.styles.js";
import "@emotion/react";
import "../../../../../components/dialog/DraggablePaperComponent.js";
import "react-draggable";
import "../../../../../components/icons/CalendarEventIcon/CalendarEventIcon.js";
import "../../../../../components/icons/MainIcon/MainIcon.js";
import "../../../../../components/icons/CalendarIcon/CalendarIcon.js";
import "../../../../../components/icons/CardIcon/CardIcon.js";
import "../../../../../components/icons/ChecklistIcon/ChecklistIcon.js";
import "../../../../../components/icons/ClockIcon/ClockIcon.js";
import "../../../../../components/icons/CloseIcon/CloseIcon.js";
import "../../../../../components/icons/EditIcon/EditIcon.js";
import "../../../../../components/icons/EmptyCalendar/EmptyCalendar.js";
import "../../../../../components/icons/EventNote/EventNote.js";
import "../../../../../components/icons/FilterIcon/FilterIcon.js";
import "../../../../../components/icons/ListIcon/ListIcon.js";
import "../../../../../components/icons/MessageBubble/MessageBubble.js";
import "../../../../../components/icons/PhoneIcon/PhoneIcon.js";
import "../../../../../components/icons/PinIcon/PinIcon.js";
import "../../../../../components/icons/SearchIcon/SearchIcon.js";
import "../../../../../components/icons/TherapyNotesIcon/TherapyNotesIcon.js";
import "../../../../../components/icons/TimerIcon/TimerIcon.js";
import "../../../../../components/icons/TreatmentChairIcon/TreatmentIcon.js";
import "../../../../../components/icons/VisibilityOffIcon/VisibilityOffIcon.js";
import "../../../../../components/icons/WarningIcon/WarningIcon.js";
import "@mui/material/MenuItem/index.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.js";
import "../../../../../components/menu-item/assets/icons/minus-circle.js";
import "../../../../../components/menu-item/assets/icons/plus-circle.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.styles.js";
import "../../../../../components/menu-item/menu-item.styles.js";
import "../../../../../components/avatar/avatar.js";
import "@mui/material/Avatar/index.js";
import "../../../../../components/avatar/avatar.styles.js";
import "@mui/material/Snackbar/index.js";
import "../../../../../components/snackbar/snackbar.types.js";
import "../../../../../components/text-field/text-field.js";
import "@mui/material/TextField/index.js";
import "../../../../../components/text-field/text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.styles.js";
import "react-i18next";
import "../../../../../type/Translations.js";
import "contentful";
import "i18next";
import "lodash/set.js";
import "remarkable";
import "remarkable-react";
import "@mui/icons-material/Timer.js";
import "@mui/material/FormControl/index.js";
import "@mui/material/InputLabel/index.js";
import "@mui/material/Select/index.js";
import "@mui/material/Box/index.js";
import "date-fns/locale";
import "../../appointment-details.types.js";
import "@tanstack/react-query";
import "../../providers/axios-provider.js";
import "axios";
const parsePatientLabel = (patient) => `${patient.firstName} ${patient.lastName} ${"birthDay" in patient ? patient.birthDay : patient.birthDate ?? ""}`;
const getFormattedDate = (date) => format(parse(date, "yyyy-MM-d", /* @__PURE__ */ new Date()), "dd.MM.yyyy");
const PatientAutocomplete = ({
  appointment,
  clinicReferenceId,
  labels,
  onAddNewPatient,
  disableAddNewPatient,
  title
}) => {
  const { control, watch, setValue } = useFormContext();
  const watchPatientReferenceId = watch("patientReferenceId");
  const watchPatient = watch("patient");
  const initialQueryValue = useMemo(() => {
    const patientData = (appointment == null ? void 0 : appointment.patient) || watchPatient;
    return patientData ? parsePatientLabel(patientData) : "";
  }, []);
  const [query, setQuery] = useState(initialQueryValue);
  const {
    data: patients,
    queryResult: { isFetching }
  } = usePatientSearch({
    query,
    clinicReferenceId
  });
  const previousPatients = usePrevious(patients);
  const patientsOptions = useMemo(
    () => (patients == null ? void 0 : patients.map((patient) => ({
      label: `${patient.firstName} ${patient.lastName} ${patient.birthDay ? getFormattedDate(patient.birthDay) : ""}`,
      value: patient
    }))) ?? [],
    [patients]
  );
  const handleInputChange = useCallback(
    debounce((event) => {
      var _a;
      if (typeof ((_a = event == null ? void 0 : event.target) == null ? void 0 : _a.value) === "string") {
        if (!event.target.value) {
          setValue("patientReferenceId", "", { shouldDirty: true, shouldValidate: true, shouldTouch: true });
        }
        setQuery(event.target.value);
      }
    }, 400),
    []
  );
  const filterOptions = useCallback(
    (options) => {
      if (disableAddNewPatient)
        return options;
      return [...options, { label: `+ ${labels.newPatientButton}` }];
    },
    [disableAddNewPatient, labels.newPatientButton]
  );
  if (!previousPatients && isFetching && initialQueryValue)
    return /* @__PURE__ */ jsx(PatientAutocompleteSkeleton, {});
  return /* @__PURE__ */ jsx(
    Controller,
    {
      name: "patientReferenceId",
      control,
      render: ({ field: { value, onChange, ...rest }, fieldState: { isTouched, error } }) => {
        const selectedPatient = patientsOptions.find(
          ({ value: patient }) => patient.referenceId === watchPatientReferenceId
        );
        const showError = !!error && isTouched;
        return /* @__PURE__ */ jsx(
          Autocomplete,
          {
            ...rest,
            onChange: (_, data) => {
              var _a;
              return onChange((_a = data == null ? void 0 : data.value) == null ? void 0 : _a.referenceId);
            },
            options: patientsOptions,
            onInputChange: handleInputChange,
            disableClearable: true,
            fullWidth: true,
            handleHomeEndKeys: true,
            selectOnFocus: true,
            autoHighlight: true,
            value: selectedPatient,
            defaultValue: selectedPatient,
            filterSelectedOptions: true,
            filterOptions,
            freeSolo: true,
            ListboxComponent: (props) => /* @__PURE__ */ jsx(StyledListbox, { ...props }),
            getOptionLabel: (option) => typeof option === "string" ? option : option.label ?? "",
            renderOption: (props, option) => {
              var _a;
              if (!option.value && disableAddNewPatient)
                return null;
              if (!option.value) {
                return /* @__PURE__ */ jsx(AddNewPatientWrapper, { children: /* @__PURE__ */ createElement(
                  StyledMenuItem,
                  {
                    ...props,
                    key: option.label,
                    onClick: onAddNewPatient
                  },
                  /* @__PURE__ */ jsx(Button, { fullWidth: true, variant: "bordered", children: option.label })
                ) });
              }
              return /* @__PURE__ */ createElement(
                MenuItem,
                {
                  ...props,
                  selected: option.value.referenceId === value,
                  key: option.value.referenceId
                },
                /* @__PURE__ */ jsx("span", { children: `${option.value.firstName} ${option.value.lastName}` }),
                ((_a = option == null ? void 0 : option.value) == null ? void 0 : _a.birthDay) ? /* @__PURE__ */ jsx(StyledLabelBirthDay, { component: "span", variant: "Lato Emphasized 2", children: `${getFormattedDate(option.value.birthDay) ?? ""}` }) : null
              );
            },
            renderInput: ({ InputProps, ...props }) => /* @__PURE__ */ jsx(
              StyledTextField,
              {
                ...props,
                fullWidth: true,
                autoFocus: true,
                label: labels.label,
                error: showError,
                helperText: showError && labels.error,
                required: true,
                labelOffset: LABEL_OFFSET,
                InputProps: {
                  ...InputProps,
                  startAdornment: /* @__PURE__ */ jsx(PatientIcon, {}),
                  title: title ?? ""
                },
                InputLabelProps: {
                  shrink: !!selectedPatient || !!query
                }
              }
            )
          }
        );
      }
    }
  );
};
export {
  PatientAutocomplete
};
